<template>
  <div>
    <h3 class="signIn-out-header">{{ $t("common.signInOut") }}</h3>

    <h3 class="signIn-out-status">
      <b>
        {{ $t("signInOut.unpermittedUsers") }}
      </b>
    </h3>

    <p class="all-paragraphs">
      {{ $tc("signInOut.userTypeModalErrMsg", 2) }}
    </p>

    <p class="error-paragraphs">{{ acl_errs.join(", ") }}.</p>

    <p v-if="!displaySingleButton" class="apply-actions-paragraphs">
      {{ $t("signInOut.otherUsersAvaialableAction") }}
    </p>

    <hr />

    <div class="btn-container">
      <template v-if="displaySingleButton">
        <button v-if="!btnValue" class="cancel-btn" @click="hideAllErrModals">
          {{ $t("common.cancel") }}
        </button>

        <button
          class="confirmation-btn"
          @click="$bvModal.hide('someExpectedNotToday')"
        >
          {{ btnValue || $t("common.next") }}
        </button>
      </template>

      <template v-else>
        <button class="confirmation-btn" @click="onSubmit">
          {{ $t("common.continue") }}
        </button>
        <button
          class="cancel-btn"
          @click="$bvModal.hide('someExpectedNotToday')"
        >
          {{ $t("common.cancel") }}
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      errs: [],
      site_name: "",
      acl_errs: "",
      err_type: "",
      displaySingleButton: false,
      btnValue: null,
      apiPayload: {},
    };
  },
  beforeMount() {
    const {
      site_name,
      acl_errs,
      err_type,
      displaySingleButton,
      btnValue,
      apiPayload,
    } = this.getModalInfo?.expected_not_today;
    this.site_name = site_name;
    this.acl_errs = acl_errs;
    this.err_type = err_type;
    this.displaySingleButton = displaySingleButton;
    this.btnValue = btnValue;
    this.apiPayload = apiPayload;
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
  },
  methods: {
    ...mapActions("dailyLogbook", ["fetchMultipleUsersData"]),
    async onSubmit() {
      await this.fetchMultipleUsersData(this.apiPayload);
      this.$router.history.current.name != "multiplesignin" &&
        this.$router.push({
          name: "multiplesignin",
          params: { multipleSignin: true },
        });
    },
    hideAllErrModals() {
      this.$bvModal.hide("someExpected");
      this.$bvModal.hide("someHost");
      this.$bvModal.hide("someExpectedNotToday");
      this.$bvModal.hide("someAttendanceMode");
    },
  },
};
</script>
<style lang="scss">
div#someExpectedNotToday___BV_modal_content_ {
  width: 579px !important;
  margin-top: 100px;
  h3.signIn-out-header {
    color: #000;

    font-size: 17px;

    font-weight: 700;
    line-height: normal;
    margin-bottom: 40px;
  }
  h3.signIn-out-status {
    color: #787878;
    text-align: center;

    font-size: 16px;

    font-weight: 700;
    line-height: 155%;
    margin-bottom: 16px;
  }
  p.all-paragraphs {
    color: var(--939393, #939393);
    text-align: center;

    font-size: 16px;

    font-weight: 400;
    line-height: 28.5px;
    letter-spacing: 0.25px;
    margin-bottom: 0px !important;
  }
  p.error-paragraphs {
    color: var(--939393, #939393);
    text-align: center;

    font-size: 16px;

    font-weight: 400;
    line-height: 28.5px;
    letter-spacing: 0.25px;
    margin-bottom: 0px !important;
  }
  p.apply-actions-paragraphs {
    color: var(--939393, #939393);
    text-align: center;

    font-size: 16px;

    font-weight: 400;
    line-height: 28.5px;
    letter-spacing: 0.25px;
    margin-top: 8px;
    margin-bottom: 0px !important;
  }
  hr {
    margin-top: 40px !important;
    margin-bottom: 20px !important;
    border: 0;
    border-top: 1px solid #707070;
    opacity: 0.15;
  }
  .btn-container {
    display: flex;
    justify-content: center;
    button.confirmation-btn {
      width: 112px;
      height: 33px;
      border-radius: 16.5px;
      background: #103f5e;
      border: none;
      color: #fff;
      text-align: center;

      font-size: 16px;

      font-weight: 400;
      line-height: normal;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-inline-end: 15px;
    }
    button.cancel-btn {
      width: 112px;
      height: 33px;
      border-radius: 16.5px;
      border: solid 1px #f46a6a;
      //border: none;
      background: #fff;
      color: #f46a6a;
      text-align: center;

      font-size: 16px;

      font-weight: 400;
      line-height: normal;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-inline-start: 15px;
      margin-inline-end: 15px;
    }
  }
}
</style>
